import React from 'react';
import { 
  Lightbulb, 
  Clock, 
  Thermometer, 
  Home, 
  Zap, 
  AlertCircle, 
  Sun, 
  BatteryCharging 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Lightbulb,
      title: 'Энергосберегающие лампы',
      description: 'Замените обычные лампы на светодиодные - экономия до 90% энергии на освещение.'
    },
    {
      icon: Clock,
      title: 'Многотарифный учет',
      description: 'Установите многотарифный счетчик для экономии до 30% на электроэнергии.'
    },
    {
      icon: Thermometer,
      title: 'Холодильник',
      description: 'Оптимальная температура в холодильнике: +3-5°C и -18°C в морозильной камере.'
    },
    {
      icon: Home,
      title: 'Бытовая техника',
      description: 'Выбирайте технику с высоким классом энергоэффективности (A, A+, A++, A+++).'
    },
    {
      icon: Zap,
      title: 'Режим ожидания',
      description: 'Выключайте приборы из розетки - в режиме ожидания они потребляют до 10% энергии.'
    },
    {
      icon: Sun,
      title: 'Естественное освещение',
      description: 'Максимально используйте дневной свет и правильно расположите рабочие зоны.'
    },
    {
      icon: BatteryCharging,
      title: 'Зарядные устройства',
      description: 'Не оставляйте зарядные устройства в розетке без подключенных устройств.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Lightbulb className="w-5 h-5 mr-2 text-green-500" />
        Советы по экономии
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Знаете ли вы?
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Замена 5 обычных ламп на светодиодные может сэкономить до 3500 рублей в год на электроэнергии.
            </p>
            <p className="text-xs text-green-600 dark:text-green-400">
              По статистике, на освещение приходится около 15% от общего потребления электроэнергии в квартире.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;